import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Case_Arrow } from "../../../../app-constants";

const Caseusa = () => {
  return (
    <section className="case_flex">
      <div className="flex_item" style={{ backgroundColor: "#6fbcdf" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../../images/services-usa/and/case-logo-1.webp"
              alt="onsite_logo"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={193}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Real-Time Social Networking App</h3>
            <Link
              to="/case-studies/onsite"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../../images/services-usa/and/case-study-1.webp"
            alt="onsite"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={675}
            height={460}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#000000" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../../images/services-usa/and/case-logo-2.webp"
              alt="pure-plank_logo"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={226}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Empowering Your Wellness Journey</h3>
            <Link
              to="/case-studies/pure-plank"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../../images/services-usa/and/case-study-2.webp"
            alt="pure-plank"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
      <div className="flex_item" style={{ backgroundColor: "#4145a9" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../../images/services-usa/and/case-logo-3.webp"
              alt="reck-n-case_logo"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={85}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>A Restaurant Booking and Socializing App</h3>
            <Link
              to="/case-studies/reck-n-case"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../../images/services-usa/and/case-study-3.webp"
            alt="reck-n-case"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={475}
          />
        </div>
      </div>
    </section>
  );
};

export default Caseusa;
